var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8501_22350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83352 16.5992V15.3334L10.1883 16.5992H8.83352ZM19.5844 7.64832L11.3961 15.3046L10.0413 14.0372L18.2296 6.38252L19.5844 7.64832ZM22 7.67386L18.2296 4.14959L7.12514 14.5315V18.0558H10.8955L22 7.67386ZM16.3504 15.8125H14.6386V19.4861H3.70838V3.51391H14.8128V4.79169H16.5212V1.91669H2V21.0834H16.3504V15.8125ZM5.41676 6.70867H12.2503V5.11145H5.41676V6.70867ZM5.41676 9.90312H9.68771V8.3059H5.41676V9.90312ZM5.41676 13.0976H7.12514V11.5003H5.41676V13.0976Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8501_22350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingProgram);
export default __webpack_public_path__ + "static/media/TrackingProgram.03b41cf8082c699a65de45d8de6c998f.svg";
export { ForwardRef as ReactComponent };